import React from "react";
import { Link } from "react-router-dom";
import { Star, Quote, Heart, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { TESTIMONIALS, TESTIMONIALS_INTRO } from "../mock";

function Stars({ count = 5 }) {
  return (
    <div className="flex items-center gap-1" data-testid="testimonial-stars">
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} size={16} className="fill-[#f5b301] text-[#f5b301]" />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page">
      {/* Header */}
      <section className="bg-gradient-to-b from-[#f3edf5] to-white pt-16 pb-10 md:pt-20 md:pb-14">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <Reveal>
            <Heart className="mx-auto text-purple mb-4" size={32} />
            <h1 className="font-serif-brand text-4xl md:text-5xl lg:text-6xl text-purple leading-tight">
              Words from those Coach Kam has helped
            </h1>
            <div className="brand-rule mx-auto mt-6" />
            <p className="mt-6 text-neutral-600 leading-relaxed max-w-2xl mx-auto">
              {TESTIMONIALS_INTRO}
            </p>
          </Reveal>
        </div>
      </section>

      {/* Testimonials grid */}
      <section className="bg-[#f7fbfa] py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={`${t.name}-${i}`} delay={(i % 3) * 120}>
                <article
                  data-testid={`testimonial-card-${i}`}
                  className="h-full flex flex-col bg-white rounded-xl border border-neutral-100 shadow-sm hover:shadow-xl transition-shadow duration-300 p-7"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <img
                      src={t.image}
                      alt={t.name}
                      loading="lazy"
                      className="w-14 h-14 rounded-full object-cover ring-2 ring-[var(--teal)]/30"
                    />
                    <div>
                      <p className="text-purple font-semibold leading-tight">{t.name}</p>
                      <p className="text-xs text-neutral-500 tracking-wide-sm">{t.role}</p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between mb-4">
                    <Stars count={t.rating} />
                    <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[var(--teal-dark)] bg-[var(--teal)]/10 rounded-full px-3 py-1">
                      {t.service}
                    </span>
                  </div>

                  <Quote className="text-[var(--teal)] mb-2" size={22} />
                  <p className="text-neutral-600 leading-relaxed text-[15px] flex-1">
                    {t.quote}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-3xl mx-auto px-5 py-16 md:py-20 text-center">
        <Reveal>
          <h2 className="font-serif-brand text-3xl md:text-4xl text-purple">
            Ready to write your own story?
          </h2>
          <p className="mt-4 text-neutral-600 leading-relaxed">
            Join the many who found healing, clarity, and balance with Coach Kam.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <Link to="/book" className="btn-brand btn-teal" data-testid="testimonials-book-btn">
              Book a Call <ArrowRight size={16} />
            </Link>
            <Link to="/services" className="btn-brand btn-outline-teal">
              Explore Services
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
